(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .factory('cashlessActions', cashlessActionsFactory);

  /** @ngInject */
  function cashlessActionsFactory(
    $q,
    api,
    dispatcher,
    ActionTypesEnum,
    $translate
  ) {
    return {
      getCashlessSales: getCashlessSales,
      refundCashlessPayment: refundCashlessPayment,
      getCashlessTotals: getCashlessTotals,
      getCashlessSalesExportCSV: getCashlessSalesExportCSV
    };

    function getCashlessSales(
      filter,
      since,
      until,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer();
      api
        .getCashlessSales(filter, since, until, page, pageSize, orderBy, order)
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            deferred.reject(errorData);
          }
        );

      return deferred.promise;
    }

    function refundCashlessPayment(id, amount) {
      var deferred = $q.defer();
      api.refundCashlessPayment(id, amount).then(
        function (data) {
          // dispatch message
          dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message: $translate.instant('REFUND_SUCCESSFULLY')
            }
          });
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function getCashlessTotals(since, until, filter) {
      var deferred = $q.defer();
      api.getCashlessTotals(since, until, filter).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function getCashlessSalesExportCSV(
      filter,
      since,
      until
    ) {
      var deferred = $q.defer();
      api
        .getCashlessSalesExportCSV(filter, since, until)
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            deferred.reject(errorData);
          }
        );

      return deferred.promise;
    }

  }
})();
